const characterImage = {
  "Luke Skywalker": "luke-skywalker",
  "C-3PO": "c3po",
  "R2-D2": "r2d2",
  "Darth Vader": "darth-vader",
  "Leia Organa": "leia-organa",
  "Owen Lars": "owen-lars",
  "Beru Whitesun lars": "beru-lars",
  "R5-D4": "r5d4",
  "Biggs Darklighter": "biggs-darklighter",
  "Obi-Wan Kenobi": "obi-wan-kenobi",
  "Anakin Skywalker": "anakin-skywalker",
  "Wilhuff Tarkin": "wilhuff-tarkin",
  "Chewbacca": "chewbacca",
  "Han Solo": "han-solo",
  "Greedo": "greedo",
  "Jabba Desilijic Tiure": "jabba",
  "Wedge Antilles": "wedge-antilles",
  "Jek Tono Porkins": "porkins",
  "Yoda": "yoda",
  "Palpatine": "palpatine",
  "Boba Fett": "boba-fett",
  "IG-88": "ig88",
  "Bossk": "bossk",
  "Lando Calrissian": "lando-calrissian",
  "Lobot": "lobot",
  "Ackbar": "ackbar",
  "Mon Mothma": "mon-mothma",
  "Arvel Crynyd": "arvel-crynyd",
  "Wicket Systri Warrick": "wicket-warrick",
  "Nien Nunb": "nien-nunb",
  "Qui-Gon Jinn": "qui-gon-jinn",
  "Nute Gunray": "nute-gunray",
  "Finis Valorum": "finis-valorum",
  "Padmé Amidala": "padme-amidala",
  "Jar Jar Binks": "jar-jar-binks",
  "Roos Tarpals": "roos-tarpals",
  "Rugor Nass": "rugor-nass",
  "Ric Olié": "ric-olie",
  "Watto": "watto",
  "Sebulba": "sebulba",
  "Quarsh Panaka": "quarsh-panaka",
  "Shmi Skywalker": "shmi-skywalker",
  "Darth Maul": "darth-maul",
  "Bib Fortuna": "bib-fortuna",
  "Ayla Secura": "ayla-secura",
  "Ratts Tyerel": "ratts-tyerel",
  "Dud Bolt": "dud-bolt",
  "Gasgano": "gasgano",
  "Ben Quadinaros": "ben-quadinaros",
  "Mace Windu": "mace-windu",
  "Ki-Adi-Mundi": "ki-adi-mundi",
  "Kit Fisto": "kit-fisto",
  "Eeth Koth": "eeth-koth",
  "Adi Gallia": "adi-gallia",
  "Saesee Tiin": "saesee-tiin",
  "Yarael Poof": "yarael-poof",
  "Plo Koon": "plo-koon",
  "Mas Amedda": "mas-amedda",
  "Gregar Typho": "gregar-typho",
  "Cordé": "corde",
  "Cliegg Lars": "cliegg-lars",
  "Poggle the Lesser": "poggle",
  "Luminara Unduli": "luminara-unduli",
  "Barriss Offee": "barriss-offee",
  "Dormé": "dorme",
  "Dooku": "dooku",
  "Bail Prestor Organa": "bail-prestor-organa",
  "Jango Fett": "jango-fett",
  "Zam Wesell": "zam-wesell",
  "Dexter Jettster": "dexter-jettster",
  "Lama Su": "lama-su",
  "Taun We": "taun-we",
  "Jocasta Nu": "jocasta-nu",
  "R4-P17": "r4p17",
  "Wat Tambor": "wat-tambor",
  "San Hill": "san-hill",
  "Shaak Ti": "shaak-ti",
  "Grievous": "grievous",
  "Tarfful": "tarfful",
  "Raymus Antilles": "raymus-antilles",
  "Sly Moore": "sly-moore",
  "Tion Medon": "tion-medon",
  "Finn": "finn",
  "Rey": "rey",
  "Poe Dameron": "poe-dameron",
  "BB8": "bb8",
  "Captain Phasma": "captain-phasma"
};

export default characterImage;